import { MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={SITE.images.hero}
          alt="Rustic mobile coffee cart at an outdoor event"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#2C2621]/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2621]/95 via-[#2C2621]/70 to-[#2C2621]/55" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28 pt-32 w-full">
        <div className="max-w-3xl animate-fade-up">
          <div className="inline-flex items-center gap-2 text-[#E5DFD3] mb-6">
            <MapPin size={16} strokeWidth={1.5} />
            <span className="uppercase tracking-[0.2em] text-xs font-semibold">
              Serving {SITE.serviceArea}
            </span>
          </div>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#FAF7F2] leading-[1.02] tracking-tight">
            Artisanal Mobile Coffee Catering for Unforgettable Events
          </h1>
          <p className="mt-7 text-lg md:text-xl text-[#E5DFD3] leading-relaxed max-w-2xl">
            We bring the authentic Kingston coffee experience — handcrafted Seattle
            espresso, Italian-style paninis, and gourmet baked goods — directly to your
            weddings, corporate gatherings, and private parties.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#quote"
              data-testid="hero-cta-quote"
              className="bg-[#8B5E3C] text-white rounded-md px-8 py-4 text-base font-semibold text-center transition-all duration-300 hover:bg-[#70482B] hover:-translate-y-1 hover:shadow-lg"
            >
              Request a Quote
            </a>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="bg-[#FAF7F2]/10 backdrop-blur-md border border-[#FAF7F2]/40 text-[#FAF7F2] rounded-md px-8 py-4 text-base font-semibold text-center transition-all duration-300 hover:bg-[#FAF7F2]/20"
            >
              Explore Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
